import React from "react";
import { connect } from "react-redux";
import { Button, Form, Input, message, Modal } from 'antd'

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicFilter from "../../components/frame/DynamicFilter";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import { changeSalaryHistory, selectSalaryHistory } from "../../actions/salary-allowance-actions";
import {
	fetchEmployeesList
} from '../../actions/employee-management-actions';
import {
	fetchDepartmentsList
} from '../../actions/department-structure-actions';
import commonService from '../../services/Common/common-service'

const { Search } = Input

class SalaryHistory extends ReduxAbstract {

	initReload = true
	deleteRowSelection = true
	moduleName = "salaryAllowance"
	childModuleName = "salaryHistory"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		passwordModalStatus:true,
		importModalStatus: false
	}

	actions = {
		changeAction: this.props.changeSalaryHistory,
		selectAction: this.props.selectSalaryHistory,
	}

	filterColumn = [{
			type: "person"
		}, {
			type: "department"
		}, {
			type: "month",
			label: "结束时间",
			key: "end_time",
		}, {
			type: "month",
			label: "开始时间",
			key: "start_time",
		}
	]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-small'
		},{
			title: '中文名',
			dataIndex: 'employee_name',
			key: 'employee_name',
			className: 'table-global-head-small'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '基本工资',
			dataIndex: 'current_base_salary',
			key: 'current_base_salary',
			className: 'table-global-head-short'
		}, {
			title: '岗位工资',
			dataIndex: 'current_post_salary',
			key: 'current_post_salary',
			className: 'table-global-head-short'
		}, {
			title: '福利补贴',
			dataIndex: 'welfare_subsidies',
			key: 'welfare_subsidies',
			className: 'table-global-head-short'
		}, {
			title: '事假',
			dataIndex: 'leave_subsidies',
			key: 'leave_subsidies',
			className: 'table-global-head-small'
		}, {
			title: '病假',
			dataIndex: 'sick_leave_subsidies',
			key: 'sick_leave_subsidies',
			className: 'table-global-head-small'
		},{
			title: '其他假期',
			dataIndex: 'other_holidays',
			key: 'other_holidays',
			className: 'table-global-head-short'
		}, {
			title: '未打卡扣款',
			dataIndex: 'not_punched_deduct',
			key: 'not_punched_deduct',
			className: 'table-global-head-6x'
		}, {
			title: '迟到扣款',
			dataIndex: 'come_late_deduct',
			key: 'come_late_deduct',
			className: 'table-global-head-short'
		}, {
			title: '旷工扣款',
			dataIndex: 'stay_away_deduct',
			key: 'stay_away_deduct',
			className: 'table-global-head-short'
		}, {
			title: '应发工资',
			dataIndex: 'wage_payable',
			key: 'wage_payable',
			className: 'table-global-head-short'
		}, {
			title: '代扣个税',
			dataIndex: 'withholding_tax',
			key: 'withholding_tax',
			className: 'table-global-head-short'
		}, {
			title: '个人养老费',
			dataIndex: 'pension_rates_personal',
			key: 'pension_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人医疗费',
			dataIndex: 'medical_rates_personal',
			key: 'medical_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人失业费',
			dataIndex: 'unemployment_rates_personal',
			key: 'unemployment_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人公积金',
			dataIndex: 'provident_fund_rates_personal',
			key: 'provident_fund_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '单位养老费',
			dataIndex: 'pension_rates_unit',
			key: 'pension_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位医疗费',
			dataIndex: 'medical_rates_unit',
			key: 'medical_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位失业费',
			dataIndex: 'unemployment_rates_unit',
			key: 'unemployment_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位工伤费',
			dataIndex: 'work_injury_rates_unit',
			key: 'work_injury_rates_unit',
			className: 'table-global-head-6x'
		},{
			title: '单位生育费',
			dataIndex: 'fertility_rates_unit',
			key: 'fertility_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位公积金',
			dataIndex: 'provident_fund_rates_unit',
			key: 'provident_fund_rates_unit',
			className: 'table-global-head-6x'
		}
	]

	customComponentWillMount() {
		this.props.fetchDepartmentsList();
	}

	togglePasswordModal = (text) => {
		commonService.checkSecondPassword({ Password : text }, (response) => {
			if (response.data.Success) {
				this.setState({
					passwordModalStatus: !this.state.passwordModalStatus
				})
			} else {
				message.error('密码错误', 4)
			}
		})
	}

	goBack = () => {
		this.props.history.goBack()
	}

	count = ()=>{
		let { time } = this.state
		let siv = setInterval(() => {
			this.setState({ time: (time--) }, () => {
				if (time <= -1) {
					clearInterval(siv)
					this.setState({ loading: false, time: 59 })
				}
			})
		}, 1000)
	}

	sendSms = (e) => {
		e.preventDefault()
		commonService.sendSms({ mobile: '15921098897' }, (response) => {
			if (response.data.Success) {
				this.setState({ loading: true })
				if (this.state.time !== 0) {
					this.count()
				}
				message.success('发送成功')
			} else {
				message.error('发送失败')
			}
		})
	}

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.dataSource().filters}
						setFilter={this.publicChange} />
				</div>
				<DynamicTable column={this.tableColumn}
					dataStatus={this.dataSource().dataStatus}
					dataSource={this.dataSource().data.Data}
					pagination={{
						total: this.dataSource().data.Total,
						pageSize: this.dataSource().data.PageSize,
						current: this.dataSource().filters.page}}
					rowSelection={this.rowSelection}
					setPageFilter={this.actions.changeAction} />
				<Modal width='300px'
					   visible={this.state.passwordModalStatus}
					   title="页面已锁定"
					   destroyOnClose={true}
					   onCancel={this.goBack}
					   footer={null}>
					<div className="app-module-header">
						<Form>
							<Form.Item>
								<Search
									placeholder="请输入二级密码"
									enterButton="确认"
									size="large"
									type="password"
									onSearch={text=>this.togglePasswordModal(text)}
								/>
							</Form.Item>
						</Form>
					</div>
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure,
	}
}

const mapDispatchToProps = {
	changeSalaryHistory,
	selectSalaryHistory,
	fetchEmployeesList,
	fetchDepartmentsList,
}

SalaryHistory = Form.create()(SalaryHistory);

SalaryHistory = connect(mapStateToProps, mapDispatchToProps)(SalaryHistory);

export default LayoutWrapper(SalaryHistory);


// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryHistory.js